import { InjectionToken } from "@angular/core";
import { ProductAddToCartDialog } from "projects/shared/lib/components/shared/product/add-to-cart-dialog/product-add-to-cart-dialog.model";


export abstract class IProductAddToCartDialogService
{

  abstract productAddToCartDialogShow(productAddToCartDialog: ProductAddToCartDialog): unknown;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductAddToCartDialogServiceToken = new InjectionToken<IProductAddToCartDialogService>('IProductAddToCartDialogServiceToken');
